import React, { useState } from 'react';

import './styles.css';
import api from '../../services';

import IconHorizontal from '../../assets/icon-horizontal.png'
import LoginForm from './LoginForm';
import ModulesMenu from './ModulesMenu';
import ChangePasswordForm from './ChangePasswordForm';

function Login(props) {
  const userType = localStorage.getItem("_userType");
  const [option, setOption] = useState(userType ? 1 : 0);
  const [formOn, setFormOn] = useState(userType ? 0 : 1);
  const [modulesOn, setModulesOn] = useState(userType ? 1 : 0);
  const pathname = props.location.pathname;

  if (userType === "acesso") {
    delete api.defaults.headers.academia;
    localStorage.removeItem("_academyInfos");
  }



  return (
    <main className="login-page">

      <section className="login-acess">
        <img src={IconHorizontal} alt="Ícone horizontal" />
        {
          pathname.includes('nova-senha') ?
            <ChangePasswordForm />
            :
            <>
              {
                option === 0 ? <LoginForm
                  hide={!formOn}
                  setOption={setOption}
                  setFormOn={setFormOn}
                  setModulesOn={setModulesOn}
                /> : []
              }
              {
                option === 1 ? <ModulesMenu hide={!modulesOn} /> : []
              }
            </>
        }
      </section>
      <section className="login-poster" />
    </main>
  );
}

export default Login;
